import React, { useState } from 'react'
import { Paper, Stack, Tooltip, Typography, List, ListItem, ListItemText } from '@mui/material'

const CheckInCoachPlayerPrompts = () => {
    const [hover, setHover] = useState(false)

    return (
        <Tooltip followCursor title='Click to view Coach & Player Prompts'>
            <Paper
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => window.open('https://drive.google.com/file/d/1UqHwLlEbPx7eOZ1A7Jb2qTPPhYMV-ebK/view', '_blank')}
                elevation={4}
                sx={{ mt: 2, p: 2, cursor: 'pointer' }}
            >
                <Typography textAlign='center' variant="h5" color="initial">Coach & Player Prompts - 1:1 Check in</Typography>
                <Stack direction='row' spacing={2}>
                    <Stack direction='row' spacing={2}>
                        <List>
                            <Typography variant="h6" color="initial">Coach Prompts:</Typography>
                            <ListItem sx={{ fontSize: 10 }}>
                                <Stack>
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        primary="What part of your day/work makes the day go by fast?" />
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        primary="What part of your day/work makes the day go by slowly?" />
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        primary="As your coach, what can I do to offer more guidance in your goals?" />
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        primary="As your coach, what am I doing well?" />
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        primary="What are some things you are proud of accomplishing or being part of recently?
                                    " />
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        primary="At our last check in, you said ____ was a challenge. How is that going for you
                                        now?" />
                                </Stack>
                            </ListItem>
                        </List>
                    </Stack>
                    <Stack>
                        <List>
                            <Typography variant="h6" color="initial">Player Prompts:</Typography>
                            <ListItem>
                                <Stack>
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        primary="If I could ask for help on one goal, it would be…" />
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        primary="I really enjoy when I'm given the responsibility or opportunity to ___
                                        because____." />
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        primary="I find I struggle when I'm given the responsibility or opportunity to____
                                        because____.
                                    " />
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        primary="I'd like to commit to ____ to move forward in my goals before we meet again.
                                    " />
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        primary="I'm really proud of accomplishing ___ since we met last." />
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        primary="After learning about my Clifton Strengths, I'd like to utilize my ___ more at
                                        work. Some
                                        ideas I have are ____.
                                    " />
                                </Stack>
                            </ListItem>
                        </List>
                    </Stack>
                </Stack>
            </Paper>
        </Tooltip>
    )
}

export default CheckInCoachPlayerPrompts